import type { ComponentProps } from 'react'
import { useIntl } from 'react-intl'
import NavBarListItem from 'components/NavKit/NavBarListItem'
import NavBarListItemIcon from 'components/NavKit/NavBarListItemIcon'
import SolidSparklesIcon from 'LuxKit/Icons/solid/SolidSparklesIcon'
import config from 'constants/config'
import { CHAT_TRIP_PLANNER_ROUTE } from 'tripPlanner/pages/chat/ChatTripPlannerPage/hooks/useChatNavigation'
import { useIsMobileOrTablet } from 'hooks/useIsMobileOrTablet'

type InheritedListItemProps = Pick<ComponentProps<typeof NavBarListItem>, 'onClick'>

function AccountMenuAITripPlannerListItem(props: InheritedListItemProps) {
  if (!config.ENABLE_TRIP_PLANNER) return null

  return <AccountMenuAITripPlannerListItemInner {...props} />
}

function AccountMenuAITripPlannerListItemInner(props: InheritedListItemProps) {
  const intl = useIntl()
  const isMobileOrTablet = useIsMobileOrTablet()
  const tripPlannerUrl = isMobileOrTablet ? '/trip-planner' : CHAT_TRIP_PLANNER_ROUTE

  const aiTripPlannerText = intl.formatMessage({
    id: 'fy6AEDM2kmm0s1MZdp8w',
    defaultMessage: 'AI TripPlanner',
    description: 'AI TripPlanner navigation button text in the account menu',
  })

  return (
    <NavBarListItem
      {...props}
      startIcon={<NavBarListItemIcon Icon={SolidSparklesIcon} colour="primary" />}
      title={aiTripPlannerText}
      to={tripPlannerUrl}
    />
  )
}

export default AccountMenuAITripPlannerListItem
